import  { alpha, type Palette, type PaletteColor, type Theme } from '@mui/material/styles';
import type { ButtonProps } from '@mui/material';

import type { PickValues } from '~/types/utils';

export const createButtonStyles = (
    { palette }: Theme,
    variant: ButtonProps['variant'],
    color: keyof PickValues<Palette, PaletteColor> | 'default' = 'primary',
) => {
    const { lighter, light, main, dark, contrastText } = palette[
        color === 'default'
            ? 'primary'
            : color === 'grey' ? 'secondary' : color];

    return {
        fontWeight: 400,
        position: 'relative',
        ...(variant === 'contained' && {
            backgroundColor: main,
            color: contrastText,
            '&:hover': { backgroundColor: dark },
        }),
        ...(variant === 'light' && {
            backgroundColor: lighter,
            color: main,
            '&:hover': { backgroundColor: light },
        }),
        ...(variant === 'outlined' && {
            backgroundColor: 'transparent',
            border: `1px solid ${main}`,
            color: main,
            '&:hover': { borderColor: dark, color: dark },
        }),
        '&::after': {
            content: '""',
            display: 'block',
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            borderRadius: 'inherit',
            opacity: 0,
            transition: 'all 0.5s',
            boxShadow: `0 0 5px 5px ${alpha(main, 0.9)}`
        },
        '&:active::after': {
            position: 'absolute',
            borderRadius: 'inherit',
            left: 0,
            top: 0,
            opacity: 1,
            transition: '0s',
            boxShadow: `0 0 0 0 ${alpha(main, 0.9)}`
        },
        '&:focus-visible': { outline: `2px solid ${dark}`, outlineOffset: 2 },
    } as const;
};
